import React, { FC } from 'react';
import { EntityType } from 'common/enums';
import {
    CHECKBOX_HIERARCHY_OFFSET_CATEGORY,
    CHECKBOX_HIERARCHY_OFFSET_SUBCATEGORY,
    CHECKBOX_HIERARCHY_OFFSET_INDICATOR
} from 'common/config';

import './FeaturesHierarchyCellRenderer.scss';
import Icon from 'common/components/base/icon';
import { ICON_COLLECTION } from 'assets/media/icons';
import { FeatureActions } from 'modules/admin-roles-management/enums/admin-role.enum';

function FeaturesHierarchyCellRenderer(props: any) {
    const { value, data, onAction, api, rowIndex } = props;
    const dynamicMargin = data.hasChild ? data.levelxyz * 16 + 12 : data.levelxyz * 16;
    const cellStyles = {
        marginLeft: `${data.levelxyz === 0 ? 16 : dynamicMargin}px`
    };
    const expansionIndicationClass =
        data.isParentExpanded || data.isExpanded ? 'checkbox-cell-cell-expanded' : '';
    const dynamicClassName = data.subFeatures ? 'name-value-light' : '';
    const nameValueClass = `name-value ${
        data.isExpanded ? 'name-value-expanded' : dynamicClassName
    }`;
    const dynanicIcon = data.isExpanded ? (
        <Icon
            className="name-icon name-icon-expanded"
            src={ICON_COLLECTION.IC_ExpandMore}
            onClick={() => onAction(null, data, FeatureActions.COLLAPSE, api, rowIndex)}
        />
    ) : (
        <Icon
            className="name-icon"
            src={ICON_COLLECTION.IC_ChevronRight}
            onClick={() => onAction(null, data, FeatureActions.Expand, api, rowIndex)}
        />
    );
    return (
        <div className={`checkbox-cell  ${expansionIndicationClass}`} title={value}>
            <div className="checkbox-cell-contents" style={cellStyles}>
                {data.hasChild ? null : <div style={{ width: '3rem' }}></div>}
                {data.hasChild ? dynanicIcon : null}

                <span className={nameValueClass}>{value}</span>
            </div>
        </div>
    );
}
export default FeaturesHierarchyCellRenderer;
